// Offline fallback list of calming lines for someone in a manic or elevated state.
// Tone is gentle, present-tense, non-judgmental. No urgency, no medical language.
// `author` is optional — original stillwater lines have none, borrowed quotes do.
export const CURATED_QUOTES = [
  { text: "This feeling is a wave. It will rise, and it will pass." },
  { text: "You do not have to be calm to be safe. You only have to breathe." },
  { text: "Slow is a valid speed. Rest is a valid response." },
  { text: "The mind can race, and the body can still be held." },
  { text: "You are not the storm. You are the sky the storm moves through." },
  { text: "Softness is not weakness. Stillness is not failure." },
  { text: "Nothing needs to be solved in this moment. Only noticed." },
  { text: "Your breath is a home you can always return to." },
  { text: "Right now, the only task is the next breath." },
  { text: "Feelings are visitors. Let them arrive. Let them leave." },
  { text: "You are allowed to slow down. You are allowed to be here." },
  { text: "Ground your feet. The floor is holding you." },
  // Attributed lines added later.
  { text: "Quiet the mind and the soul will speak.", author: "Ma Jaya Sati Bhagavati" },
  { text: "The present moment is filled with joy and happiness. If you are attentive, you will see it.", author: "Thich Nhat Hanh" },
  { text: "Nature does not hurry, yet everything is accomplished.", author: "Lao Tzu" },
  { text: "Allow yourself to anchor right where you are.", author: "Unknown" },
  { text: "There is virtue in work and there is virtue in rest. Use both and overlook neither.", author: "Alan Cohen" },
  { text: "You don't have to carry it all right now.", author: "Unknown" },
  { text: "This, too, shall pass.", author: "Persian Adage" },
  { text: "Deep rivers run quiet.", author: "Proverb" },
];

export const pickCurated = (avoidText) => {
  const pool = avoidText
    ? CURATED_QUOTES.filter((q) => q.text !== avoidText)
    : CURATED_QUOTES;
  return pool[Math.floor(Math.random() * pool.length)];
};
